import { getFrontEndApi } from '@app/core/services/utils/util.service';
import { FronteggThemeOptions, FronteggAppOptions } from '@frontegg/types';
export const FronteggLocalization: FronteggAppOptions['localizations'] = {
  en: {
    errors: {},
    loginBox: {
      login: {
        login: 'Log in',
        passwordInputPlaceholder: 'Enter your password',
        forgotPassword: 'Forgot password?',
      },
    },
  },
};

const LOGO_URL = 'assets/images/login/pdq_login_logo.svg';

export const fronteggThemeOptions: FronteggThemeOptions = {
  loginBox: {
    boxStyle: {
      borderRadius: '16px',
    },
    poweredByPlacement: 'page',
    themeName: 'classic',
    logo: { image: `${getFrontEndApi()}${LOGO_URL}` },
    palette: {
      primary: {
        main: '#6033FA',
        hover: '#604FC3',
        active: '#6033FA',
        light: '#CCCDD2',
        contrastText: 'white',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            borderRadius: '8px',
            boxShadow: '0 16px 32px #D9D5ED',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '16px',
            border: 'none',
            '&:hover': {
              backgroundColor: '#6033FA',
              boxShadow: '0px 16px 32px rgba(110, 91, 216, 0.24)',
            },
          },
        },
      },
    },
  },
};
